import styled from '@emotion/styled'

export const Text14 = styled.span`
  font-size: 14px;
`
export const Text18 = styled.span`
  font-size: 18px;
`
